import { logger } from '../services/logger';

SvgUpload.$inject = ['$resource'];

/**
 * @typedef {import('./types').SvgUpload} SvgUpload
 */

/**
 * @typedef {'getNaviSvgPreview' | 'getNaviFinal' | 'getNaviSvgFinal'} FetchImageMethods
 */

/**
 * @param {angular.resource.IResourceService} $resource
 */
export function SvgUpload($resource) {
  /** @type {SvgUpload} */
  const api = /** @type {any} */ (
    $resource(
      '',
      {},
      {
        updateSectionAvailability: {
          method: 'POST',
          url: '/api/section/:id/availability',
        },
        getNaviSvgPreview: {
          method: 'GET',
          url: '/api/house/:id/svg/preview',
          isArray: true,
        },
        getNaviSvgFinal: {
          method: 'GET',
          url: '/api/house/:id/svg/final',
          isArray: true,
        },
        getNaviSource: {
          method: 'GET',
          url: '/api/house/:id/image/source',
          isArray: true,
        },
        getNaviDraft: {
          method: 'GET',
          url: '/api/house/:id/image/draft',
          isArray: true,
        },
        getNaviPreview: {
          method: 'GET',
          url: '/api/house/:id/image/preview',
          isArray: true,
        },
        getNaviFinal: {
          method: 'GET',
          url: '/api/house/:id/image/final',
          isArray: true,
        },
        approveImages: {
          method: 'POST',
          url: '/api/house/:id/imagesApprove',
        },
      },
    )
  );

  /** @type {(houseId: string | number, method: FetchImageMethods) => Promise<string | null>} */
  const fetchImage = async (houseId, method) =>
    api[method]({
      id: houseId,
    }).$promise.then(
      (resp) => {
        if (!resp.length) {
          return null;
        }

        return resp[resp.length - 1].url.replace(/^http:/, 'https:');
      },
      (error) => {
        logger.error('Error fetching image', {
          error,
          houseId,
          method,
        });

        return null;
      },
    );

  api.fetchImages = async ({ houseId, finalOnly = true }) => {
    const [previewSvg, finalImage, finalSvg] = await Promise.all([
      finalOnly ? null : fetchImage(houseId, 'getNaviSvgPreview'),
      fetchImage(houseId, 'getNaviFinal'),
      fetchImage(houseId, 'getNaviSvgFinal'),
    ]);

    return { previewSvg, finalImage, finalSvg };
  };

  return api;
}
